import { withStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  closePickupConfirmation,
  closePickupRevokeConfirmation,
} from '../../store/actions/containerActions';
import {
  getPickupConfirmationContainers,
  getPickupConfirmationOpen,
  getPickupRevokeConfirmationOpen,
  getPickupRevokeConfirmationContainers,
  getOldAlfapassNumber,
} from '../../store/selectors/selectors';
import { LABEL, DIALOG, FORMATTING } from '../../theme/constants';

const styles = () => ({
  dialogContentWithNewLines: {
    whiteSpace: 'pre-wrap',
  },
});

const PickupConfirmationDialog = (props) => {
  const {
    classes,
    pickupConfirmationOpen,
    pickupRevokeConfirmationOpen,
    pickupContainers,
    pickupRevokeContainers,
    closePickupConfirmation,
    closePickupRevokeConfirmation,
    alfapassNumber,
  } = props;

  const [setTextFieldErrored] = React.useState(false);

  const confirmationActions = (
    <div>
      <Button onClick={closePickupConfirmation} color="primary">
        {LABEL.CLOSE}
      </Button>
    </div>
  );

  return (
    <>
      <Dialog
        open={pickupConfirmationOpen}
        onClose={() => {
          closePickupConfirmation();
          setTextFieldErrored(false);
        }}
        fullWidth={true}
        maxWidth={'md'}
        aria-labelledby={'pickup-confirm'}
      >
        <DialogTitle aria-labelledby={'pickup-confirm-title'}>
          {DIALOG.CONFIRMATION_TITLE}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogContentWithNewLines} color="textSecondary">
            {DIALOG.PICKUP_CONFIRMATION_CONTENT.replace(
              FORMATTING.CONTAINER_BL_NUMBER_LIST,
              pickupContainers
                .map((container) => {
                  return (
                    container.equipmentNumber +
                    '\t - \t[' +
                    container.billOfLadingNumbers.join(', ') +
                    ']'
                  );
                })
                .join('\n ')
            ).replace(FORMATTING.ALFAPASS_NUMBER, alfapassNumber)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{confirmationActions}</DialogActions>
      </Dialog>
      <Dialog
        open={pickupRevokeConfirmationOpen}
        onClose={() => {
          closePickupRevokeConfirmation();
          setTextFieldErrored(false);
        }}
        fullWidth={true}
        maxWidth={'md'}
        aria-labelledby={'pickup-revoke-confirm'}
      >
        <DialogTitle aria-labelledby={'pickup-revoke-confirm-title'}>
          {DIALOG.CONFIRMATION_TITLE}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogContentWithNewLines} color="textSecondary">
            {DIALOG.PICKUP_REVOKE_CONFIRMATION_CONTENT.replace(
              FORMATTING.CONTAINER_BL_NUMBER_LIST,
              pickupRevokeContainers
                .map((container) => {
                  return (
                    container.equipmentNumber +
                    '\t - \t[' +
                    container.billOfLadingNumbers.join(', ') +
                    ']'
                  );
                })
                .join('\n ')
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closePickupRevokeConfirmation} color="primary">
            {LABEL.CLOSE}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

function mapStateToProps(state) {
  return {
    pickupConfirmationOpen: getPickupConfirmationOpen(state),
    pickupRevokeConfirmationOpen: getPickupRevokeConfirmationOpen(state),
    pickupContainers: getPickupConfirmationContainers(state),
    pickupRevokeContainers: getPickupRevokeConfirmationContainers(state),
    alfapassNumber: getOldAlfapassNumber(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      closePickupConfirmation,
      closePickupRevokeConfirmation,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(PickupConfirmationDialog, styles));
